
import { PropType } from 'vue'
import NrIcon from '../NrIcon/NrIcon.vue'
import NrIconButton from '../NrIconButton/nr-icon-button.vue'

interface TableHeader {
  label: string
  field: string
  hidden?: boolean
  sticky?: boolean
  sortable?: boolean
}

interface TableRow {
  [key: string]: any
}

export default {
  components: { NrIcon, NrIconButton },

  props: {
    striped: Boolean,
    isLoading: {
      type: Boolean,
      default: false
    },
    tableName: {
      type: String,
      default() {
        return 'data'
      }
    },
    columns: {
      type: Array as PropType<TableHeader[]>,
      default() {
        return []
      }
    },
    rows: {
      type: Array as PropType<TableRow[]>,
      default() {
        return []
      }
    },
    emptyText: {
      type: String,
      default() {
        return ''
      }
    }
  },

  data() {
    return {
      config: {}
    }
  },

  computed: {
    columnFields() {
      return this.parsedColumns.map((column) => column.field)
    },

    parsedColumns() {
      return this.columns.filter((column) => !column.hidden)
    },

    parsedRows() {
      return this.rows.map((row) => {
        return this.columnFields
          .map((field) => ({ [field]: row[field] }))
          .reduce((newRow, column) => Object.assign(newRow, column, row), {})
      })
    }
  },

  methods: {
    getColumnDataByField(field) {
      return this.parsedColumns.find((column) => field === column.field)
    },

    handleTableSort(field) {
      const order = this.config[field]?.order === 'desc' ? 'asc' : 'desc'
      this.config = { [field]: { order } }
      this.$emit('sort', { field, order })
    },

    sortIcon(field) {
      if (this.config[field]?.order) {
        return this.config[field].order === 'desc' ? 'sort-down' : 'sort-up'
      } else {
        return 'sort'
      }
    }
  }
}
